import { IArrayGridFilter, TeamsPlusMoreDynamicValues, defaultOperatorFactories } from "@gtmhub/shared/components/grid-filtering-bar";
import { RestLayerFilter } from "../../core/rest-layer";

export const generateDynamicTeamIdsFilter = (filter: IArrayGridFilter): RestLayerFilter => {
  const { fieldName, dataType, operator, value, dynamicValues } = filter;
  const baseFilter = { fieldName, dataType, operator };
  const defaultFactory = defaultOperatorFactories[operator];
  const queryFilter = [];

  if (value?.length) {
    queryFilter.push(defaultFactory({ ...baseFilter, value, fieldName: "teamIds" }), defaultFactory({ ...baseFilter, value, fieldName: "managedTeamIds" }));
  }

  if (dynamicValues?.length) {
    const dynamicIds = filter.dynamicValues.map((dv) => (dv as TeamsPlusMoreDynamicValues).teamId);
    queryFilter.push(
      defaultFactory({ ...baseFilter, value: dynamicIds, fieldName: "teamIds_teamsAndSubTeams" }),
      defaultFactory({ ...baseFilter, value: dynamicIds, fieldName: "managedTeamIds_teamsAndSubTeams" })
    );
  }

  return { ["$or"]: queryFilter };
};
